(function () {
  "use strict";

  /* ---------- Arranque: cada módulo se inicializa por separado y con su
     propio try/catch, para que un fallo en uno (DOM inesperado, API del
     navegador ausente, etc.) no impida que arranquen los demás. Antes todo
     el archivo era un único bloque secuencial: una excepción en cualquier
     punto abortaba silenciosamente todo lo que venía después. ---------- */
  function safeInit(name, fn) {
    try {
      fn();
    } catch (err) {
      console.error("[dmp-theme] \"" + name + "\" no se pudo inicializar:", err);
    }
  }

  /* ---------- Eventos GA4 (CLAUDE.md sección 9 / doc estratégico 12.2) ---------- */
  function dmpTrack(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
  }

  /* ---------- Mapa/lista de regiones (solo home): evento cambio_region ---------- */
  function initRegionTracking() {
    var dmpRegionLinks = document.querySelectorAll("[data-dmp-region]");
    dmpRegionLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        dmpTrack("cambio_region", { region: link.getAttribute("data-dmp-region") });
      });
    });
  }

  /* ---------- Carrito: evento add_to_cart (GA4 ecommerce) ---------- */
  function initAddToCartTracking() {
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      /* Solo "product-form" (formulario normal de producto, incluye el quick
         add "standard" porque reutiliza el mismo flujo). El quick add "bulk"
         (assets/quick-add-bulk.js) publica el carrito completo -- {items:[...]}-
         no un ítem suelto, así que tratarlo aquí como item.id/item.price
         estaría mal. Hoy quick_add está en "none" en templates/collection.json
         (nadie lo activa), así que no hay nada que trackear todavía; si se
         activa "bulk" en el futuro, esto necesita su propio manejo (iterar
         event.cartData.items) probado en vivo, no una adaptación a ciegas. */
      if (event.source !== "product-form") return;
      var item = event.cartData;
      if (!item || !item.id) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      dmpTrack("add_to_cart", {
        ecommerce: {
          currency: window.dmpCurrency,
          value: (item.price * item.quantity) / 100,
          items: [{
            item_id: String(item.product_id),
            item_name: item.product_title,
            item_variant: item.variant_title,
            price: item.price / 100,
            quantity: item.quantity
          }]
        }
      });
    });
  }

  /* ---------- Header scroll state ---------- */
  function initHeaderScroll() {
    var header = document.getElementById("dmpSiteHeader");
    var backToTop = document.getElementById("dmpBackToTop");

    if (header) {
      window.addEventListener(
        "scroll",
        function () {
          var y = window.scrollY || document.documentElement.scrollTop;
          header.classList.toggle("is-scrolled", y > 8);
          if (backToTop) backToTop.classList.toggle("is-visible", y > 500);
        },
        { passive: true }
      );
    }
    if (backToTop) {
      backToTop.addEventListener("click", function () {
        window.scrollTo({
          top: 0,
          behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        });
      });
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var hamburger = document.getElementById("dmpHamburgerBtn");
    var mobileNav = document.getElementById("dmpMobileNav");
    var mobileNavClose = document.getElementById("dmpMobileNavClose");
    if (!hamburger || !mobileNav) return;

    var openMobileNav = function () {
      mobileNav.classList.add("is-open");
      hamburger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    };
    var closeMobileNav = function () {
      mobileNav.classList.remove("is-open");
      hamburger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    };
    hamburger.addEventListener("click", function () {
      mobileNav.classList.contains("is-open") ? closeMobileNav() : openMobileNav();
    });
    if (mobileNavClose) mobileNavClose.addEventListener("click", closeMobileNav);
    document.querySelectorAll("[data-dmp-nav-link]").forEach(function (a) {
      a.addEventListener("click", closeMobileNav);
    });
  }

  /* ---------- Hero slider (solo home) ---------- */
  function initHeroSlider() {
    var slides = Array.prototype.slice.call(document.querySelectorAll(".dmp-hero-slide"));
    var dots = Array.prototype.slice.call(document.querySelectorAll("#dmpSlideDots button"));
    if (!slides.length || !dots.length) return;

    var currentSlide = 0,
      slideTimer;
    var goToSlide = function (i) {
      slides[currentSlide].classList.remove("is-active");
      dots[currentSlide].classList.remove("is-active");
      dots[currentSlide].setAttribute("aria-selected", "false");
      currentSlide = i;
      slides[currentSlide].classList.add("is-active");
      dots[currentSlide].classList.add("is-active");
      dots[currentSlide].setAttribute("aria-selected", "true");
    };
    var nextSlide = function () {
      goToSlide((currentSlide + 1) % slides.length);
    };
    var stopAutoplay = function () {
      clearInterval(slideTimer);
    };
    var startAutoplay = function () {
      if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      stopAutoplay();
      slideTimer = setInterval(nextSlide, 5500);
    };
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        goToSlide(parseInt(dot.dataset.slide, 10));
        startAutoplay();
      });
    });
    var heroVisual = document.querySelector(".dmp-hero-visual");
    if (heroVisual) {
      heroVisual.addEventListener("mouseenter", stopAutoplay);
      heroVisual.addEventListener("mouseleave", startAutoplay);
    }
    startAutoplay();
  }

  /* ---------- Carrusel de tarjetas (leyendas / vegetales músicos): número de
     columnas = tarjetas visibles. Evita una columna "fantasma" vacía cuando
     hay menos tarjetas activas que el máximo de 5 (grid-template-columns fijo
     dejaba un hueco en blanco). Parametrizado porque la home usa el mismo
     carrusel dos veces (leyendas destacadas y vegetales músicos). */
  function updateCarouselCols(trackId, cardSelector, cssVar) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var visible = track.querySelectorAll(cardSelector + ":not(.is-hidden)").length;
    if (visible > 0) track.style.setProperty(cssVar, Math.min(visible, 5));
  }

  /* ---------- Carrusel de tarjetas: "ver todas" (solo home) ---------- */
  function initCarouselToggle(btnId, trackId, cardSelector, cssVar) {
    var verTodasBtn = document.getElementById(btnId);
    if (!verTodasBtn) return;

    var cards = document.querySelectorAll(cardSelector);
    var showAllExtras = false;

    verTodasBtn.addEventListener("click", function () {
      showAllExtras = !showAllExtras;
      verTodasBtn.innerHTML = showAllExtras ? verTodasBtn.dataset.labelLess : verTodasBtn.dataset.labelMore;
      verTodasBtn.setAttribute("aria-expanded", showAllExtras ? "true" : "false");
      cards.forEach(function (card) {
        if (card.hasAttribute("data-extra")) card.classList.toggle("is-hidden", !showAllExtras);
      });
      updateCarouselCols(trackId, cardSelector, cssVar);
    });
  }

  /* ---------- Carrusel de tarjetas: flechas + arrastre con mouse ---------- */
  function initDragCarousel(trackId, prevId, nextId, cardSelector, cssVar) {
    var track = document.getElementById(trackId);
    if (!track) return;

    updateCarouselCols(trackId, cardSelector, cssVar);

    var prevBtn = document.getElementById(prevId);
    var nextBtn = document.getElementById(nextId);
    var scrollByStep = function (dir) {
      var card = track.querySelector(cardSelector);
      var step = card ? card.getBoundingClientRect().width + 2 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    };
    if (prevBtn) prevBtn.addEventListener("click", function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { scrollByStep(1); });

    /* Arrastre con mouse — overflow-x:auto solo responde a touch/scrollbar de forma
       nativa, no a click-and-drag con mouse, que es como muchos usuarios de
       escritorio intentan moverlo primero. */
    var isDown = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener("mousedown", function (e) {
      isDown = true;
      moved = false;
      track.classList.add("is-dragging");
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });
    window.addEventListener("mouseup", function () {
      isDown = false;
      track.classList.remove("is-dragging");
    });
    track.addEventListener("mouseleave", function () {
      isDown = false;
      track.classList.remove("is-dragging");
    });
    track.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    /* Evita que un arrastre termine también disparando el click al link de la card. */
    track.addEventListener(
      "click",
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  /* ---------- Vault: modal solicitar acceso (solo home) ---------- */
  function initVaultModal() {
    var vaultModal = document.getElementById("dmpVaultModal");
    if (!vaultModal) return;

    var vaultAccessBtn = document.getElementById("dmpVaultAccessBtn");
    var notifyMeBtns = document.querySelectorAll("[data-dmp-notify]");
    var modalCloseBtn = document.getElementById("dmpModalCloseBtn");
    var modalForm = document.getElementById("dmpModalForm");
    var modalSuccess = document.getElementById("dmpModalSuccess");
    var modalSuccessClose = document.getElementById("dmpModalSuccessClose");
    var vaultForm = document.getElementById("dmpVaultForm");

    /* Devuelve el foco a quien abrió el modal (puede ser cualquiera de los
       varios triggers: hero, tarjeta Vault, nav header/móvil, footer,
       vault-cta) en vez de perderlo en el body al cerrar. */
    var lastFocused = null;
    var getFocusable = function () {
      return Array.prototype.slice.call(
        vaultModal.querySelectorAll('button:not([disabled]), [href], input, textarea, select, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        return el.offsetParent !== null;
      });
    };
    var openModal = function (e) {
      lastFocused = e && e.currentTarget ? e.currentTarget : document.activeElement;
      vaultModal.classList.add("is-open");
      vaultModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      var nameInput = document.getElementById("dmpVaultName");
      if (nameInput) nameInput.focus();
    };
    var closeModal = function () {
      vaultModal.classList.remove("is-open");
      vaultModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (modalForm) modalForm.style.display = "";
      if (modalSuccess) modalSuccess.classList.remove("is-visible");
      if (vaultForm) vaultForm.reset();
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      lastFocused = null;
    };

    if (vaultAccessBtn) vaultAccessBtn.addEventListener("click", openModal);
    notifyMeBtns.forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });
    if (modalCloseBtn) modalCloseBtn.addEventListener("click", closeModal);
    if (modalSuccessClose) modalSuccessClose.addEventListener("click", closeModal);
    vaultModal.addEventListener("click", function (e) {
      if (e.target === vaultModal) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (!vaultModal.classList.contains("is-open")) return;
      if (e.key === "Escape") {
        closeModal();
        return;
      }
      /* Trampa de foco: con el modal abierto, Tab/Shift+Tab no deben poder
         salir hacia el contenido de fondo. */
      if (e.key === "Tab") {
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    if (!vaultForm) return;

    var brevoUrl = vaultForm.getAttribute("data-brevo-action");
    var brevoNameField = vaultForm.getAttribute("data-brevo-name-field") || "NOM";
    var modalError = document.getElementById("dmpModalError");
    var vaultSubmitBtn = vaultForm.querySelector('button[type="submit"]');

    vaultForm.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!vaultForm.checkValidity()) {
        vaultForm.reportValidity();
        return;
      }
      if (modalError) modalError.hidden = true;

      if (!brevoUrl) {
        /* Brevo no configurado todavía (falta la URL del formulario en los
           ajustes de la sección Vault) — mantiene el éxito simulado para no
           romper el build antes de tener la cuenta lista. */
        modalForm.style.display = "none";
        modalSuccess.classList.add("is-visible");
        dmpTrack("vault_solicitud", { brevo_configurado: false });
        return;
      }

      var payload = new FormData();
      payload.append("EMAIL", document.getElementById("dmpVaultEmail").value);
      payload.append(brevoNameField, document.getElementById("dmpVaultName").value);
      payload.append("email_address_check", "");
      payload.append("locale", "es");

      if (vaultSubmitBtn) vaultSubmitBtn.disabled = true;

      /* mode: "no-cors" es obligatorio porque sibforms.com no devuelve
         cabeceras CORS — a cambio la respuesta es opaca: no podemos leer si
         Brevo aceptó el contacto, solo si la petición de red salió. Un fallo
         de validación silencioso en Brevo (p.ej. campo mal mapeado) no se
         detectará aquí; revisar el contact count en Brevo tras el primer test. */
      fetch(brevoUrl, {
        method: "POST",
        mode: "no-cors",
        body: payload
      })
        .then(function () {
          modalForm.style.display = "none";
          modalSuccess.classList.add("is-visible");
          dmpTrack("vault_solicitud", { brevo_configurado: true });
        })
        .catch(function () {
          if (modalError) modalError.hidden = false;
        })
        .finally(function () {
          if (vaultSubmitBtn) vaultSubmitBtn.disabled = false;
        });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initScrollReveal() {
    var revealEls = document.querySelectorAll("[data-dmp-reveal]");
    if (!revealEls.length) return;

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add("is-visible");
      });
    }
  }

  /* ---------- Active nav link on scroll (solo home) ---------- */
  function initActiveNavOnScroll() {
    var sectionIds = ["dmp-inicio", "universos", "vault", "sobre", "contacto"];
    var sections = sectionIds.map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);
    var navLinks = document.querySelectorAll(".dmp-main-nav a");
    if (!("IntersectionObserver" in window) || !sections.length) return;

    var navIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            navLinks.forEach(function (link) {
              var href = link.getAttribute("href") || "";
              link.classList.toggle("is-active", href.indexOf("#" + id) !== -1);
            });
          }
        });
      },
      { rootMargin: "-45% 0px -50% 0px" }
    );
    sections.forEach(function (s) {
      navIo.observe(s);
    });
  }

  safeInit("region-tracking", initRegionTracking);
  safeInit("add-to-cart-tracking", initAddToCartTracking);
  safeInit("header-scroll", initHeaderScroll);
  safeInit("mobile-menu", initMobileMenu);
  safeInit("hero-slider", initHeroSlider);
  safeInit("leyendas-toggle", function () {
    initCarouselToggle("dmpVerTodasBtn", "dmpLeyendasTrack", ".dmp-legend-card", "--dmp-leyendas-cols");
  });
  safeInit("leyendas-carousel", function () {
    initDragCarousel("dmpLeyendasTrack", "dmpLeyendasPrev", "dmpLeyendasNext", ".dmp-legend-card", "--dmp-leyendas-cols");
  });
  safeInit("vegetales-toggle", function () {
    initCarouselToggle("dmpVerTodosVegetalesBtn", "dmpVegetalesTrack", ".dmp-vegetal-card", "--dmp-vegetales-cols");
  });
  safeInit("vegetales-carousel", function () {
    initDragCarousel("dmpVegetalesTrack", "dmpVegetalesPrev", "dmpVegetalesNext", ".dmp-vegetal-card", "--dmp-vegetales-cols");
  });
  safeInit("vault-modal", initVaultModal);
  safeInit("scroll-reveal", initScrollReveal);
  safeInit("active-nav-on-scroll", initActiveNavOnScroll);
})();
